import { Button } from 'twyne-new.ui'

import { useThemeTypes } from '@/modules/cms/views/post/components/builder/context'

export default function AddButton({ children, color = 'accent', variant, className, size }) {
  const types = useThemeTypes()

  return <Button
    color={color}
    variant={variant}
    className={className}
    size={size}
    onClick={() => types.add('New Content Type')}
  >
    {children}
  </Button>
}
